import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import jquery from "jquery";

/* import FaderLogo from "./v4/header/logo.js"; */

import TopExpanded from "./v4/header/TopExpanded.js";
/* import TopStatic from "./v4/header/TopStatic.js"; */

class HeaderV4 extends React.Component {
  /* componentDidMount() {
   *   this.scrollHandler = throttle(this.checkWindowScroll, this.props.throttle);
   * } */

  handleIsVisible = isVisible => {
    console.log("handleIsVisible:", isVisible);

    if (isVisible) {
      jquery(".headerbar").css({ display: "none" });
    } else {
      jquery(".headerbar").css({ display: "flex" });
    }
  };

  render() {
    return (
      <div>
        <VisibilitySensor
          onChange={this.handleIsVisible}
          offset={{ top: -240 }}
        >
          <TopExpanded />
        </VisibilitySensor>
      </div>
    );
  }
}

export default HeaderV4;
